import ajax from '@ajax';

/**
 * Wall-E API
 * Wall-E 知识库问答系统 API 文档
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */
const basePath = '/'.replace(/\/$/, '');
/**
  * 基本信息接口
  * @param params ParamsgetApeInfoApi
  
  * @param opt ajax config
  * @returns models.APEInfoResponse
  */
const getApeInfoApi = (params, opt) => {
    const path = '/api/ape/info';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('conversationId' in params)
        p.query.conversationId = params.conversationId;
    ajax.check(params.conversationId, 'conversationId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 版本发布接口
  * @param params ParamspostApeVersionApi
  * @param data: ParamsBodypostApeVersionApi
  * @param opt ajax config
  * @returns models.VersionPublishResponse
  */
const postApeVersionApi = (params, data, opt) => {
    const path = '/api/ape/version/publish';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 删除会话
  
  * @param data: ParamsBodydeleteConversationApi
  * @param opt ajax config
  * @returns models.DeleteConversationResponse
  */
const deleteConversationApi = (data, opt) => {
    const path = '/api/conversation';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'DELETE',
        url,
        ...p
    });
};
/**
  * 获取会话详情
  * @param params ParamsgetConversationDetailApi
  
  * @param opt ajax config
  * @returns models.ConversationDetailResponse
  */
const getConversationDetailApi = (params, opt) => {
    const path = '/api/conversation/detail';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('conversationId' in params)
        p.query.conversationId = params.conversationId;
    ajax.check(params.conversationId, 'conversationId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取会话事件列表
  * @param params ParamsgetConversationEventsApi
  
  * @param opt ajax config
  * @returns models.ConversationEventsResponse
  */
const getConversationEventsApi = (params, opt) => {
    const path = '/api/conversation/{conversation_id}/events';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.conversation_id, 'conversation_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取会话列表
  * @param params ParamsgetConversationListApi
  
  * @param opt ajax config
  * @returns models.ConversationListResponse
  */
const getConversationListApi = (params, opt) => {
    const path = '/api/conversation/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取LLM调用追踪
  * @param params ParamsgetConversationLlmTraceApi
  
  * @param opt ajax config
  * @returns {}
  */
const getConversationLlmTraceApi = (params, opt) => {
    const path = '/api/conversation/llm/trace';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('conversationId' in params)
        p.query.conversationId = params.conversationId;
    ajax.check(params.conversationId, 'conversationId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetConversationMsgEventStreamApi
  
  * @param opt ajax config
  * @returns {}
  */
const getConversationMsgEventStreamApi = (params, opt) => {
    const path = '/api/conversation/conversation/{conversationId}/event/stream';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('startTime' in params)
        p.query.startTime = params.startTime;
    ajax.check(params.startTime, 'startTime');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.conversationId, 'conversationId');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取会话列表
  * @param params ParamsgetConversationPageListApi
  
  * @param opt ajax config
  * @returns models.ConversationPageListResponse
  */
const getConversationPageListApi = (params, opt) => {
    const path = '/api/conversation/page-list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('tag' in params)
        p.query.tag = params.tag;
    if ('page_size' in params)
        p.query.page_size = params.page_size;
    if ('page' in params)
        p.query.page = params.page;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取运行中的会话
  * @param params ParamsgetConversationRunningApi
  
  * @param opt ajax config
  * @returns models.ConversationRunningResponse
  */
const getConversationRunningApi = (params, opt) => {
    const path = '/api/conversation/running';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 搜索会话
  * @param params ParamsgetConversationSearchApi
  
  * @param opt ajax config
  * @returns models.ConversationSearchResponse
  */
const getConversationSearchApi = (params, opt) => {
    const path = '/api/conversation/search';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('keyword' in params)
        p.query.keyword = params.keyword;
    ajax.check(params.keyword, 'keyword');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetConversationShareApi
  
  * @param opt ajax config
  * @returns models.ConversationShareListResponse
  */
const getConversationShareApi = (params, opt) => {
    const path = '/api/conversation/conversation/{conversationId}/share';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.conversationId, 'conversationId');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 创建会话
  * @param params ParamspostConversationApi
  * @param data: ParamsBodypostConversationApi
  * @param opt ajax config
  * @returns models.CreateConversationResponse
  */
const postConversationApi = (params, data, opt) => {
    const path = '/api/conversation';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 发送消息
  * @param params ParamspostConversationChatApi
  * @param data: ParamsBodypostConversationChatApi
  * @param opt ajax config
  * @returns models.ConversationChatResponse
  */
const postConversationChatApi = (params, data, opt) => {
    const path = '/api/conversation/{id}/chat';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.id, 'id');
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 会话终止
  * @param params ParamspostConversationChatStopApi
  
  * @param opt ajax config
  * @returns models.ConversationStopResponse
  */
const postConversationChatStopApi = (params, opt) => {
    const path = '/api/conversation/{id}/stop';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    ajax.check(params.id, 'id');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 批量获取会话详情
  * @param params ParamspostConversationDetailsApi
  * @param data: ParamsBodypostConversationDetailsApi
  * @param opt ajax config
  * @returns models.ConversationDetailsResponse
  */
const postConversationDetailsApi = (params, data, opt) => {
    const path = '/api/conversation/details';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 重命名会话
  
  * @param data: ParamsBodypostConversationRenameApi
  * @param opt ajax config
  * @returns models.RenameConversationResponse
  */
const postConversationRenameApi = (data, opt) => {
    const path = '/api/conversation/rename';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamspostConversationShareApi
  * @param data: ParamsBodypostConversationShareApi
  * @param opt ajax config
  * @returns {}
  */
const postConversationShareApi = (params, data, opt) => {
    const path = '/api/conversation/conversation/{conversationId}/share';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.conversationId, 'conversationId');
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 用户操作
  * @param params ParamspostConversationUserOperatedApi
  
  * @param opt ajax config
  * @returns {}
  */
const postConversationUserOperatedApi = (params, opt) => {
    const path = '/api/conversation/conversation/{operateType}/{helpId}';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.operateType, 'operateType');
    ajax.check(params.helpId, 'helpId');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 获取cookie列表
  * @param params ParamsgetCookieListApi
  
  * @param opt ajax config
  * @returns models.CookieListResponse
  */
const getCookieListApi = (params, opt) => {
    const path = '/api/cookie/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 修改cookie启用禁用状态
  * @param params ParamspostCookieEnableApi
  * @param data: ParamsBodypostCookieEnableApi
  * @param opt ajax config
  * @returns models.CookieEnableResponse
  */
const postCookieEnableApi = (params, data, opt) => {
    const path = '/api/cookie/enable';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 修改cookie全局启用禁用状态
  * @param params ParamspostCookieGlobalDisableApi
  * @param data: ParamsBodypostCookieGlobalDisableApi
  * @param opt ajax config
  * @returns models.CookieEnableResponse
  */
const postCookieGlobalDisableApi = (params, data, opt) => {
    const path = '/api/cookie/global_disable';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * LLM调试接口
  * @summary LLM调试接口
  * @param params ParamspostLlmDebugApi
  * @param data: ParamsBodypostLlmDebugApi
  * @param opt ajax config
  * @returns models.LlmDebugResponse
  */
const postLlmDebugApi = (params, data, opt) => {
    const path = '/api/debug/llm_debug';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('agent_name' in params)
        p.query.agent_name = params.agent_name;
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 提交用户反馈
  * @summary 提交用户反馈（赞或踩）
  * @param params ParamspostSubmitFeedbackApi
  * @param data: ParamsBodypostSubmitFeedbackApi
  * @param opt ajax config
  * @returns models.FeedbackResponse
  */
const postSubmitFeedbackApi = (params, data, opt) => {
    const path = '/api/feedback/submit';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetFileConvertMdToPdf
  
  * @param opt ajax config
  * @returns {}
  */
const getFileConvertMdToPdf = (params, opt) => {
    const path = '/api/file/convert_html_to_docx/{object_key}';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.object_key, 'object_key');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetFileConvertToPdf
  
  * @param opt ajax config
  * @returns {}
  */
const getFileConvertToPdf = (params, opt) => {
    const path = '/api/file/convert_html_to_pdf/{object_key}';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.object_key, 'object_key');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetFileDownload
  
  * @param opt ajax config
  * @returns {}
  */
const getFileDownload = (params, opt) => {
    const path = '/api/file/download/{object_key}';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.object_key, 'object_key');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  
  
  * @param opt ajax config
  * @returns {}
  */
const getLlmTest = (opt) => {
    const path = '/api/file/test';
    const url = basePath + path;
    const p = {};
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamspostFilePostDocs
  
  * @param opt ajax config
  * @returns {}
  */
const postFilePostDocs = (params, opt) => {
    const path = '/api/file/post_docs/{object_key}';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.object_key, 'object_key');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 文件上传接口
  * @param params ParamspostFileUpload
  
  * @param opt ajax config
  * @returns {}
  */
const postFileUpload = (params, opt) => {
    const path = '/api/file/upload';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.form = {};
    // 上传文件
    opt = {
        ...opt,
        headers: {
            ...(opt && opt.headers),
            'Content-Type': 'multipart/form-data'
        }
    };
    p.form = new FormData();
    if ('file' in params)
        p.form.append('file', params.file);
    ajax.check(params.file, 'file');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 从数据库查询指定批次的测试结果，生成格式化的Excel报告供下载
  * @summary 下载GAIA批量测试结果Excel报告
  * @param params ParamsdownloadBatchTestExcel
  
  * @param opt ajax config
  * @returns {}
  */
const downloadBatchTestExcel = (params, opt) => {
    const path = '/api/gaia/batch-test/{batch_id}/download';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    ajax.check(params.batch_id, 'batch_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 获取GAIA批量测试文件上传页面
  
  
  * @param opt ajax config
  * @returns {}
  */
const gaiaUploadPage = (opt) => {
    const path = '/api/gaia/upload';
    const url = basePath + path;
    const p = {};
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 混合查询策略：数据库肯定要查（历史），内存查运行中的（实时）
  * @summary 获取GAIA批量测试的详细结果
  * @param params ParamsgetBatchTestResults
  
  * @param opt ajax config
  * @returns {}
  */
const getBatchTestResults = (params, opt) => {
    const path = '/api/gaia/batch-test/{batch_id}/results';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    ajax.check(params.batch_id, 'batch_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 混合查询策略：数据库肯定要查（历史），内存查运行中的（实时）
  * @summary 查询GAIA批量测试任务状态和进度
  * @param params ParamsgetBatchTestStatus
  
  * @param opt ajax config
  * @returns models.GaiaBatchTestStatusResponse
  */
const getBatchTestStatus = (params, opt) => {
    const path = '/api/gaia/batch-test/{batch_id}/status';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    ajax.check(params.batch_id, 'batch_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 从数据库查询用户所有的batch任务历史，包括正在运行和已完成的
  * @summary 查询当前用户的批量测试历史
  
  
  * @param opt ajax config
  * @returns models.MyBatchesResponse
  */
const getMyBatches = (opt) => {
    const path = '/api/gaia/my-batches';
    const url = basePath + path;
    const p = {};
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必须上传metadata.jsonl文件来提供测试用例
  * @summary 启动GAIA批量测试（智能任务队列）
  * @param params ParamsstartGaiaBatchTest
  
  * @param opt ajax config
  * @returns models.GaiaBatchTestResponse
  */
const startGaiaBatchTest = (params, opt) => {
    const path = '/api/gaia/batch-test';
    const url = basePath + path;
    const p = {};
    p.form = {};
    if ('testCount' in params)
        p.form.testCount = params.testCount;
    if ('maxConcurrent' in params)
        p.form.maxConcurrent = params.maxConcurrent;
    // 上传文件
    opt = {
        ...opt,
        headers: {
            ...(opt && opt.headers),
            'Content-Type': 'multipart/form-data'
        }
    };
    p.form = new FormData();
    if ('metadata_file' in params)
        p.form.append('metadata_file', params.metadata_file);
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 同时执行以下操作： 1. 终止批次中所有正在运行的会话对话 2. 将批次状态设置为终止，停止执行新的测试用例 3. 通知所有worker停止工作，不再从任务队列获取新任务
  * @summary 一键终止GAIA批量测试批次
  * @param params ParamsstopBatchTestConversations
  
  * @param opt ajax config
  * @returns models.GaiaBatchTestStopResponse
  */
const stopBatchTestConversations = (params, opt) => {
    const path = '/api/gaia/batch-test/{batch_id}/stop';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    ajax.check(params.batch_id, 'batch_id');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 健康检查接口
  
  
  * @param opt ajax config
  * @returns {}
  */
const getHealthCheck = (opt) => {
    const path = '/api/health/';
    const url = basePath + path;
    const p = {};
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 读取CSV文件头
  * @param params ParamsgetReadCsvHeaderController
  
  * @param opt ajax config
  * @returns models.ReadCsvHeaderResponse
  */
const getReadCsvHeaderController = (params, opt) => {
    const path = '/api/internal_audit/read_csv_header';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('file_id' in params)
        p.query.file_id = params.file_id;
    ajax.check(params.file_id, 'file_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 开始分析
  * @param params ParamsgetStartAnalysisController
  
  * @param opt ajax config
  * @returns models.StartAnalysisResponse
  */
const getStartAnalysisController = (params, opt) => {
    const path = '/api/internal_audit/start_analysis';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('context' in params)
        p.query.context = params.context;
    ajax.check(params.context, 'context');
    if ('file_id' in params)
        p.query.file_id = params.file_id;
    ajax.check(params.file_id, 'file_id');
    if ('conversation_id' in params)
        p.query.conversation_id = params.conversation_id;
    ajax.check(params.conversation_id, 'conversation_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 文件分析回调接口
  
  * @param data: ParamsBodypostAnalysisBackApi
  * @param opt ajax config
  * @returns {}
  */
const postAnalysisBackApi = (data, opt) => {
    const path = '/api/internal_audit/analyze_callback';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 内部审计对话，发送用户消息 该接口会立即返回，实际的审计处理会在后台线程中异步执行
  * @summary 处理内部审计对话请求
  * @param params ParamspostInternalAuditChatController
  * @param data: ParamsBodypostInternalAuditChatController
  * @param opt ajax config
  * @returns models.InternalAuditChatResponse
  */
const postInternalAuditChatController = (params, data, opt) => {
    const path = '/api/internal_audit/{conversation_id}/chat';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.conversation_id, 'conversation_id');
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 内部审计对话，停止对话
  * @param params ParamspostInternalAuditChatStopApi
  
  * @param opt ajax config
  * @returns models.InternalAuditChatStopResponse
  */
const postInternalAuditChatStopApi = (params, opt) => {
    const path = '/api/internal_audit/{conversation_id}/stop';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    ajax.check(params.conversation_id, 'conversation_id');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 内部审计数据清洗
  * @summary 内部审计数据清洗
  
  * @param data: ParamsBodypostInternalAuditDataCleaningApi
  * @param opt ajax config
  * @returns models.InternalAuditDataCleaningResponse
  */
const postInternalAuditDataCleaningApi = (data, opt) => {
    const path = '/api/internal_audit/data/cleaning';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 获取知识库列表
  * @param params ParamsgetKnowledgeListApi
  
  * @param opt ajax config
  * @returns models.KnowledgeListResponse
  */
const getKnowledgeListApi = (params, opt) => {
    const path = '/api/knowledge/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 保存知识库片段
  * @param params ParamspostKnowledgeAddApi
  * @param data: ParamsBodypostKnowledgeAddApi
  * @param opt ajax config
  * @returns models.KnowledgeAddResponse
  */
const postKnowledgeAddApi = (params, data, opt) => {
    const path = '/api/knowledge/save';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 保存知识库系统agent片段
  * @param params ParamspostKnowledgeAddSystemKnowledgeApi
  * @param data: ParamsBodypostKnowledgeAddSystemKnowledgeApi
  * @param opt ajax config
  * @returns models.KnowledgeAddSystemKnowledgeResponse
  */
const postKnowledgeAddSystemKnowledgeApi = (params, data, opt) => {
    const path = '/api/knowledge/save_system_knowledge';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 创建知识库索引
  * @param params ParamspostKnowledgeCreateIndexApi
  
  * @param opt ajax config
  * @returns models.KnowledgeCreateIndexResponse
  */
const postKnowledgeCreateIndexApi = (params, opt) => {
    const path = '/api/knowledge/create_index';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 删除知识库片段
  * @param params ParamspostKnowledgeDeleteApi
  * @param data: ParamsBodypostKnowledgeDeleteApi
  * @param opt ajax config
  * @returns models.KnowledgeDeleteResponse
  */
const postKnowledgeDeleteApi = (params, data, opt) => {
    const path = '/api/knowledge/delete';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 修改知识库启用禁用状态
  * @param params ParamspostKnowledgeEnableApi
  * @param data: ParamsBodypostKnowledgeEnableApi
  * @param opt ajax config
  * @returns models.KnowledgeEnableResponse
  */
const postKnowledgeEnableApi = (params, data, opt) => {
    const path = '/api/knowledge/enable';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 添加白名单
  * @param params ParamsgetAddWhiteList
  
  * @param opt ajax config
  * @returns {}
  */
const getAddWhiteList = (params, opt) => {
    const path = '/api/login/add_white_list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('ticket' in params)
        p.query.ticket = params.ticket;
    if ('userId' in params)
        p.query.userId = params.userId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * sso登录接口
  * @param params ParamsgetLogin
  
  * @param opt ajax config
  * @returns {}
  */
const getLogin = (params, opt) => {
    const path = '/api/login/login';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('redirect_url' in params)
        p.query.redirect_url = params.redirect_url;
    if ('ticket' in params)
        p.query.ticket = params.ticket;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * mario管理接口
  * @param params ParamsgetFastActionApi
  
  * @param opt ajax config
  * @returns models.FastActionResponse
  */
const getFastActionApi = (params, opt) => {
    const path = '/api/mario/actions';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取会话中的文件列表
  * @param params ParamsgetFileApi
  
  * @param opt ajax config
  * @returns models.FileResponse
  */
const getFileApi = (params, opt) => {
    const path = '/api/mario/files/{conversation_id}';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.conversation_id, 'conversation_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 深度搜索开关
  * @summary 获取深度搜索开关状态
  * @param params ParamsgetMarioDeepSearchApi
  
  * @param opt ajax config
  * @returns models.DeepSearchResponse
  */
const getMarioDeepSearchApi = (params, opt) => {
    const path = '/api/mario/search/deep-search';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取有权限的MCP列表
  * @summary 获取Mario MCP列表
  * @param params ParamsgetMarioMcpConfigListApi
  
  * @param opt ajax config
  * @returns models.McpConfigListResponse
  */
const getMarioMcpConfigListApi = (params, opt) => {
    const path = '/api/mario/mcp/config/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('type' in params)
        p.query.type = params.type;
    ajax.check(params.type, 'type');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取Mario 已启用MCP预览
  * @summary 获取Mario MCP预览
  * @param params ParamsgetMarioMcpConfigPreviewApi
  
  * @param opt ajax config
  * @returns models.McpConfigPreviewResponse
  */
const getMarioMcpConfigPreviewApi = (params, opt) => {
    const path = '/api/mario/mcp/config/preview';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取Mario MCP市场列表
  * @summary 获取Mario MCP市场列表
  * @param params ParamsgetMarioMcpMarketListApi
  
  * @param opt ajax config
  * @returns models.McpMarketListResponse
  */
const getMarioMcpMarketListApi = (params, opt) => {
    const path = '/api/mario/mcp/market/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取会话搜索配置
  * @summary 获取会话搜索配置 - 返回已启用的搜索类型列表
  * @param params ParamsgetMarioSearchConfigApi
  
  * @param opt ajax config
  * @returns models.SearchConfigResponse
  */
const getMarioSearchConfigApi = (params, opt) => {
    const path = '/api/mario/{conversation_id}/search/config';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.conversation_id, 'conversation_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 搜索类型配置
  * @summary 获取搜索类型配置
  * @param params ParamsgetMarioSearchTypesApi
  
  * @param opt ajax config
  * @returns models.SearchTypesResponse
  */
const getMarioSearchTypesApi = (params, opt) => {
    const path = '/api/mario/search/types';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * mario用例接口
  * @param params ParamsgetShowCaseApi
  
  * @param opt ajax config
  * @returns models.ShowCaseResponse
  */
const getShowCaseApi = (params, opt) => {
    const path = '/api/mario/showcases';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * sso登录接口
  * @param params ParamsgetSsoLogin
  
  * @param opt ajax config
  * @returns {}
  */
const getSsoLogin = (params, opt) => {
    const path = '/api/mario/sso-login';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('redirect_url' in params)
        p.query.redirect_url = params.redirect_url;
    if ('ticket' in params)
        p.query.ticket = params.ticket;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * Args:     conversation_id (str): 会话ID  Returns:     FlaskResponse: 包含SSE流的响应
  * @summary 获取工具使用事件的流式数据。
  * @param params ParamsgetToolUsedEventStreamApi
  
  * @param opt ajax config
  * @returns {}
  */
const getToolUsedEventStreamApi = (params, opt) => {
    const path = '/api/mario/{conversation_id}/tool-used/stream';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('streamId' in params)
        p.query.streamId = params.streamId;
    ajax.check(params.streamId, 'streamId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.conversation_id, 'conversation_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 与mario聊天接口
  * @param params ParamspostChatApi
  * @param data: ParamsBodypostChatApi
  * @param opt ajax config
  * @returns models.ChatResponse
  */
const postChatApi = (params, data, opt) => {
    const path = '/api/mario/{conversation_id}/chat';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    ajax.check(params.conversation_id, 'conversation_id');
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 更新深度搜索开关
  * @param params ParamspostMarioDeepSearchApi
  * @param data: ParamsBodypostMarioDeepSearchApi
  * @param opt ajax config
  * @returns {}
  */
const postMarioDeepSearchApi = (params, data, opt) => {
    const path = '/api/mario/search/deep-search';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * Mario MCP 更新认证信息
  * @summary Mario MCP Openapi更新认证
  * @param params ParamspostMarioMcpAuthUpdate
  * @param data: ParamsBodypostMarioMcpAuthUpdate
  * @param opt ajax config
  * @returns models.MarioMcpAuthUpdateResponse
  */
const postMarioMcpAuthUpdate = (params, data, opt) => {
    const path = '/api/mario/mcp/market/auth/update';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * Mario MCP Bpm认证
  * @summary Mario MCP Bpm认证
  * @param params ParamspostMarioMcpBpmAuth
  * @param data: ParamsBodypostMarioMcpBpmAuth
  * @param opt ajax config
  * @returns models.MarioMcpBpmAuthResponse
  */
const postMarioMcpBpmAuth = (params, data, opt) => {
    const path = '/api/mario/mcp/market/auth/bpm';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 标记用户已点击创建按钮
  * @summary 标记用户已点击创建按钮
  * @param params ParamspostMarioMcpMarkFirstCreateClickedApi
  
  * @param opt ajax config
  * @returns models.McpConfigPreviewMarkFirstCreateClickedResponse
  */
const postMarioMcpMarkFirstCreateClickedApi = (params, opt) => {
    const path = '/api/mario/mcp/mark_first_create_clicked';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * Mario MCP普通认证
  * @summary Mario MCP普通认证
  * @param params ParamspostMarioMcpNormalAuth
  * @param data: ParamsBodypostMarioMcpNormalAuth
  * @param opt ajax config
  * @returns models.MarioMcpNormalAuthResponse
  */
const postMarioMcpNormalAuth = (params, data, opt) => {
    const path = '/api/mario/mcp/market/auth/normal';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * Mario MCP取消认证
  * @summary Mario MCP取消认证
  * @param params ParamspostMarioMcpUnauth
  * @param data: ParamsBodypostMarioMcpUnauth
  * @param opt ajax config
  * @returns models.MarioMcpUnauthResponse
  */
const postMarioMcpUnauth = (params, data, opt) => {
    const path = '/api/mario/mcp/market/auth/cancel';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 更新搜索类型配置
  * @param params ParamspostMarioSearchTypesApi
  * @param data: ParamsBodypostMarioSearchTypesApi
  * @param opt ajax config
  * @returns {}
  */
const postMarioSearchTypesApi = (params, data, opt) => {
    const path = '/api/mario/search/types';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 启用/禁用Mario MCP配置
  * @summary 启用/禁用Mario MCP配置
  * @param params ParamspostMcpEnableConfigApi
  * @param data: ParamsBodypostMcpEnableConfigApi
  * @param opt ajax config
  * @returns models.MarioMcpEnableConfigResponse
  */
const postMcpEnableConfigApi = (params, data, opt) => {
    const path = '/api/mario/mcp/config/enable';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 创建会话并发送消息的一体化接口
  * @param params ParamspostQuickChatApi
  * @param data: ParamsBodypostQuickChatApi
  * @param opt ajax config
  * @returns models.QuickChatResponse
  */
const postQuickChatApi = (params, data, opt) => {
    const path = '/api/mario/quick-chat';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 风险检测数据查询接口 - 输入自然语言，转换为SQL后通过MySQL查询 1. 接收自然语言查询 2. 调用 text2sql 转换为 SQL 3. 通过 MySQL 执行 SQL 查询
  * @summary 风险检测数据查询接口
  * @param params ParamspostRiskDetectionQueryApi
  * @param data: ParamsBodypostRiskDetectionQueryApi
  * @param opt ajax config
  * @returns models.RiskDetectionQueryResponse
  */
const postRiskDetectionQueryApi = (params, data, opt) => {
    const path = '/api/mario/tiangong/query';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * Text2SQL接口 - 将自然语言转换为SQL，可选执行查询 将自然语言转换为 SQL，可选执行查询
  * @summary Text2SQL 接口
  * @param params ParamspostText2SqlApi
  * @param data: ParamsBodypostText2SqlApi
  * @param opt ajax config
  * @returns {}
  */
const postText2SqlApi = (params, data, opt) => {
    const path = '/api/mario/tiangong/text2sql';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 删除指定的定时任务（软删除，不会真正删除数据）
  * @summary 删除指定的定时任务
  * @param params ParamsmarioSchedulerDelete
  
  * @param opt ajax config
  * @returns models.DeleteResponse
  */
const marioSchedulerDelete = (params, opt) => {
    const path = '/api/mario/scheduler/delete/{config_id}';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    ajax.check(params.config_id, 'config_id');
    return ajax.ajax({
        ...opt,
        method: 'DELETE',
        url,
        ...p
    });
};
/**
  * 根据 config_id 查询定时任务详情
  * @summary 根据 config_id 查询任务详情
  * @param params ParamsmarioSchedulerDetail
  
  * @param opt ajax config
  * @returns models.TaskDetailResponse
  */
const marioSchedulerDetail = (params, opt) => {
    const path = '/api/mario/scheduler/detail/{config_id}';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    ajax.check(params.config_id, 'config_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 更新定时任务的启用/禁用状态
  * @summary 更新任务的启用状态
  * @param params ParamsmarioSchedulerEnabled
  * @param data: ParamsBodymarioSchedulerEnabled
  * @param opt ajax config
  * @returns models.EnabledResponse
  */
const marioSchedulerEnabled = (params, data, opt) => {
    const path = '/api/mario/scheduler/enabled/{config_id}';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    ajax.check(params.config_id, 'config_id');
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'PUT',
        url,
        ...p
    });
};
/**
  * 获取定时任务列表（支持分页）
  * @summary 查询当前用户的定时任务列表
  * @param params ParamsmarioSchedulerList
  
  * @param opt ajax config
  * @returns models.TaskListResponse
  */
const marioSchedulerList = (params, opt) => {
    const path = '/api/mario/scheduler/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('page' in params)
        p.query.page = params.page;
    if ('page_size' in params)
        p.query.page_size = params.page_size;
    if ('enabled' in params)
        p.query.enabled = params.enabled;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 查询定时任务的执行记录列表（支持分页）
  * @summary 查询定时任务的执行记录
  * @param params ParamsmarioSchedulerRecordList
  
  * @param opt ajax config
  * @returns models.RecordListResponse
  */
const marioSchedulerRecordList = (params, opt) => {
    const path = '/api/mario/scheduler/record/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('config_id' in params)
        p.query.config_id = params.config_id;
    if ('page' in params)
        p.query.page = params.page;
    if ('page_size' in params)
        p.query.page_size = params.page_size;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 立即运行指定的定时任务：创建一个新的会话并触发任务执行。前端收到 conversation_id 后可跳转到新会话查看执行进度。
  * @summary 立即运行指定的定时任务
  
  * @param data: ParamsBodymarioSchedulerRun
  * @param opt ajax config
  * @returns models.MarioSchedulerRunResponse
  */
const marioSchedulerRun = (data, opt) => {
    const path = '/api/mario/scheduler/run';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 创建或更新定时任务。创建时不传 config_id，更新时必传 config_id
  
  * @param data: ParamsBodymarioSchedulerSave
  * @param opt ajax config
  * @returns models.SaveTaskResponse
  */
const marioSchedulerSave = (data, opt) => {
    const path = '/api/mario/scheduler/save';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 获取MCP配置
  * @summary 获取MCP配置
  * @param params ParamsgetMcpConfigApi
  
  * @param opt ajax config
  * @returns models.McpConfigResponse
  */
const getMcpConfigApi = (params, opt) => {
    const path = '/api/mcp/config';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取自定义MCP列表
  * @summary 获取自定义MCP列表
  * @param params ParamsgetMcpCustomListApi
  
  * @param opt ajax config
  * @returns models.McpCustomListResponse
  */
const getMcpCustomListApi = (params, opt) => {
    const path = '/api/mcp/custom/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取官方MCP列表
  * @param params ParamsgetMcpOfficialListApi
  
  * @param opt ajax config
  * @returns models.McpOfficialListResponse
  */
const getMcpOfficialListApi = (params, opt) => {
    const path = '/api/mcp/official/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 添加自定义MCP配置
  * @summary 添加自定义MCP配置
  * @param params ParamspostMcpAddCustomConfigApi
  * @param data: ParamsBodypostMcpAddCustomConfigApi
  * @param opt ajax config
  * @returns models.McpAddCustomConfigResponse
  */
const postMcpAddCustomConfigApi = (params, data, opt) => {
    const path = '/api/mcp/custom/config/add';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 删除自定义MCP配置
  * @summary 删除自定义MCP配置
  * @param params ParamspostMcpDeleteCustomConfigApi
  * @param data: ParamsBodypostMcpDeleteCustomConfigApi
  * @param opt ajax config
  * @returns models.McpDeleteCustomConfigResponse
  */
const postMcpDeleteCustomConfigApi = (params, data, opt) => {
    const path = '/api/mcp/custom/config/delete';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 编辑自定义MCP配置
  * @summary 编辑自定义MCP配置
  * @param params ParamspostMcpEditCustomConfigApi
  * @param data: ParamsBodypostMcpEditCustomConfigApi
  * @param opt ajax config
  * @returns models.McpEditCustomConfigResponse
  */
const postMcpEditCustomConfigApi = (params, data, opt) => {
    const path = '/api/mcp/custom/config/edit';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 启用/禁用自定义MCP配置
  * @summary 启用/禁用自定义MCP配置
  * @param params ParamspostMcpEnableCustomConfigApi
  * @param data: ParamsBodypostMcpEnableCustomConfigApi
  * @param opt ajax config
  * @returns models.McpEnableCustomConfigResponse
  */
const postMcpEnableCustomConfigApi = (params, data, opt) => {
    const path = '/api/mcp/custom/config/enable';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 填充消息接口
  
  * @param data: ParamsBodypostMessageSenderApi
  * @param opt ajax config
  * @returns models.MessageSenderResponse
  */
const postMessageSenderApi = (data, opt) => {
    const path = '/api/message_sender/send';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 根据 mario_token cookie 值从 Redis 获取用户信息（无需鉴权）
  * @param params ParamsgetGetUserInfoApi
  
  * @param opt ajax config
  * @returns {}
  */
const getGetUserInfoApi = (params, opt) => {
    const path = '/api/openapi/check-token';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('token_value' in params)
        p.query.token_value = params.token_value;
    ajax.check(params.token_value, 'token_value');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取openapi会话详情
  * @summary 获取openapi会话详情
  * @param params ParamsgetOpenApiChatDetailApi
  
  * @param opt ajax config
  * @returns models.OpenApiChatDetailResponse
  */
const getOpenApiChatDetailApi = (params, opt) => {
    const path = '/api/openapi/chat/detail';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('userKey' in params)
        p.query.userKey = params.userKey;
    if ('runId' in params)
        p.query.runId = params.runId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * openapi发起会话
  * @summary 发起openapi会话
  * @param params ParamspostOpenApiChatApi
  
  * @param opt ajax config
  * @returns models.OpenApiChatResponse
  */
const postOpenApiChatApi = (params, opt) => {
    const path = '/api/openapi/chat';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 获取定时任务列表
  * @param params ParamsgetSchedulerListApi
  
  * @param opt ajax config
  * @returns models.SchedulerListResponse
  */
const getSchedulerListApi = (params, opt) => {
    const path = '/api/scheduler/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取定时任务执行记录
  * @param params ParamsgetSchedulerRecordListApi
  
  * @param opt ajax config
  * @returns models.SchedulerRecordListResponse
  */
const getSchedulerRecordListApi = (params, opt) => {
    const path = '/api/scheduler/record/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('page_size' in params)
        p.query.page_size = params.page_size;
    if ('page' in params)
        p.query.page = params.page;
    if ('config_id' in params)
        p.query.config_id = params.config_id;
    ajax.check(params.config_id, 'config_id');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 删除定时任务配置
  * @param params ParamspostSchedulerDeleteApi
  * @param data: ParamsBodypostSchedulerDeleteApi
  * @param opt ajax config
  * @returns models.SchedulerDeleteResponse
  */
const postSchedulerDeleteApi = (params, data, opt) => {
    const path = '/api/scheduler/delete';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 修改定时任务启用禁用状态
  * @param params ParamspostSchedulerEnabledApi
  * @param data: ParamsBodypostSchedulerEnabledApi
  * @param opt ajax config
  * @returns models.SchedulerEnabledResponse
  */
const postSchedulerEnabledApi = (params, data, opt) => {
    const path = '/api/scheduler/enabled';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 保存定时任务配置
  * @param params ParamspostSchedulerSaveApi
  * @param data: ParamsBodypostSchedulerSaveApi
  * @param opt ajax config
  * @returns models.SchedulerSaveResponse
  */
const postSchedulerSaveApi = (params, data, opt) => {
    const path = '/api/scheduler/save';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 获取基础统计数据
  * @summary 获取基础统计数据
  * @param params ParamsgetBasicDataApi
  
  * @param opt ajax config
  * @returns models.BasicDataResponse
  */
const getBasicDataApi = (params, opt) => {
    const path = '/api/statistic/basic_data';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('conversation_id' in params)
        p.query.conversation_id = params.conversation_id;
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取机器人数据统计(T-1日)
  * @summary 获取机器人数据统计(T-1日)
  * @param params ParamsgetRobotStatsApi
  
  * @param opt ajax config
  * @returns models.RobotStatsResponse
  */
const getRobotStatsApi = (params, opt) => {
    const path = '/api/statistic/robot_stats';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('date' in params)
        p.query.date = params.date;
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 中止所有任务
  * @param params ParamsgetTaskAbortAllApi
  
  * @param opt ajax config
  * @returns {}
  */
const getTaskAbortAllApi = (params, opt) => {
    const path = '/api/task/abort_all';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 中止任务
  * @param params ParamsgetTaskAbortApi
  
  * @param opt ajax config
  * @returns models.TaskAbortResponse
  */
const getTaskAbortApi = (params, opt) => {
    const path = '/api/task/abort';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('execution_id' in params)
        p.query.execution_id = params.execution_id;
    ajax.check(params.execution_id, 'execution_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 创建任务
  * @param params ParamsgetTaskCreateApi
  
  * @param opt ajax config
  * @returns models.TaskCreateResponse
  */
const getTaskCreateApi = (params, opt) => {
    const path = '/api/task/create';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取任务列表
  * @param params ParamsgetTaskGetTasksApi
  
  * @param opt ajax config
  * @returns models.TaskGetTasksResponse
  */
const getTaskGetTasksApi = (params, opt) => {
    const path = '/api/task/get_tasks';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 根据 template_id 查询模版详情（仅返回有效模版）
  * @param params ParamsgetTemplateDetailApi
  
  * @param opt ajax config
  * @returns {}
  */
const getTemplateDetailApi = (params, opt) => {
    const path = '/api/template/detail';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('template_id' in params)
        p.query.template_id = params.template_id;
    ajax.check(params.template_id, 'template_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取模版列表，可按 category 筛选
  * @param params ParamsgetTemplateListApi
  
  * @param opt ajax config
  * @returns {}
  */
const getTemplateListApi = (params, opt) => {
    const path = '/api/template/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('category' in params)
        p.query.category = params.category;
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 新增或修改模版。修改时传 template_id 与要改的字段；新增时不传 template_id（随机生成）或传则用该 id，并传 category/name/template_type/image_url/prompt/example，default_order 可选、默认 0
  * @param params ParamspostTemplateSaveApi
  * @param data: ParamsBodypostTemplateSaveApi
  * @param opt ajax config
  * @returns {}
  */
const postTemplateSaveApi = (params, data, opt) => {
    const path = '/api/template/save';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 查看或使用模版，type=view 记查看示例，type=use 记使用并写用户使用表
  * @param params ParamspostTemplateViewApi
  * @param data: ParamsBodypostTemplateViewApi
  * @param opt ajax config
  * @returns {}
  */
const postTemplateViewApi = (params, data, opt) => {
    const path = '/api/template/view';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 查询测试历史记录列表，按时间倒序，最多10条
  * @param params ParamsgetTestListApi
  
  * @param opt ajax config
  * @returns models.TestListResponse
  */
const getTestListApi = (params, opt) => {
    const path = '/api/test/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 列出 LLMModels 中可用的 model，供 test_prompt 选择
  * @param params ParamsgetTestListModelsApi
  
  * @param opt ajax config
  * @returns models.TestModelsResponse
  */
const getTestListModelsApi = (params, opt) => {
    const path = '/api/test/models';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 列出 ToolRegistry 中已注册的所有 tool，供 test_prompt 勾选
  * @param params ParamsgetTestListToolsApi
  
  * @param opt ajax config
  * @returns models.TestToolsResponse
  */
const getTestListToolsApi = (params, opt) => {
    const path = '/api/test/tools';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 快速测试Agent接口，自动创建会话并执行
  * @param params ParamspostTestAgentApi
  * @param data: ParamsBodypostTestAgentApi
  * @param opt ajax config
  * @returns models.TestAgentResponse
  */
const postTestAgentApi = (params, data, opt) => {
    const path = '/api/test/agent';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 测试 prompt：传入 system_prompt、human_message、model，流式返回 LLM 结果
  * @param params ParamspostTestPromptApi
  * @param data: ParamsBodypostTestPromptApi
  * @param opt ajax config
  * @returns {}
  */
const postTestPromptApi = (params, data, opt) => {
    const path = '/api/test/prompt';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 根据conversation_id从历史记录重新执行Agent
  * @param params ParamspostTestRetryApi
  * @param data: ParamsBodypostTestRetryApi
  * @param opt ajax config
  * @returns models.TestRetryResponse
  */
const postTestRetryApi = (params, data, opt) => {
    const path = '/api/test/retry';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.payload');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 获取 moltbook 群内 claw 机器人数量
  * @param params ParamsgetGroupClawCountApi
  
  * @param opt ajax config
  * @returns models.GroupClawCountResponse
  */
const getGroupClawCountApi = (params, opt) => {
    const path = '/api/user/group/claw-count';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('groupId' in params)
        p.query.groupId = params.groupId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 查询群组信息
  * @param params ParamsgetGroupQueryApi
  
  * @param opt ajax config
  * @returns models.GroupQueryResponse
  */
const getGroupQueryApi = (params, opt) => {
    const path = '/api/user/query/group';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('pageSize' in params)
        p.query.pageSize = params.pageSize;
    if ('pageNum' in params)
        p.query.pageNum = params.pageNum;
    if ('query' in params)
        p.query.query = params.query;
    ajax.check(params.query, 'query');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 根据用户 username 判断是否在 kim 群内
  * @param params ParamsgetInKimGroupApi
  
  * @param opt ajax config
  * @returns models.InKimGroupResponse
  */
const getInKimGroupApi = (params, opt) => {
    const path = '/api/user/in-kim-group';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('groupId' in params)
        p.query.groupId = params.groupId;
    ajax.check(params.groupId, 'groupId');
    if ('username' in params)
        p.query.username = params.username;
    ajax.check(params.username, 'username');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取当前用户信息
  * @param params ParamsgetUserApi
  
  * @param opt ajax config
  * @returns models.UserInfo
  */
const getUserApi = (params, opt) => {
    const path = '/api/user/info';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 查询用户和群组信息
  * @param params ParamsgetUserGroupQueryApi
  
  * @param opt ajax config
  * @returns models.UserGroupQueryResponse
  */
const getUserGroupQueryApi = (params, opt) => {
    const path = '/api/user/query';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('pageSize' in params)
        p.query.pageSize = params.pageSize;
    if ('pageNum' in params)
        p.query.pageNum = params.pageNum;
    if ('query' in params)
        p.query.query = params.query;
    ajax.check(params.query, 'query');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 查询用户信息
  * @param params ParamsgetUserQueryApi
  
  * @param opt ajax config
  * @returns models.UserQueryResponse
  */
const getUserQueryApi = (params, opt) => {
    const path = '/api/user/query/user';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('pageSize' in params)
        p.query.pageSize = params.pageSize;
    if ('pageNum' in params)
        p.query.pageNum = params.pageNum;
    if ('query' in params)
        p.query.query = params.query;
    ajax.check(params.query, 'query');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 拉当前用户进 kim molt_book 群，无需入参；成功返回 200 无 data，失败返回原因
  
  
  * @param opt ajax config
  * @returns models.JoinMoltBookGroupResponse
  */
const postJoinMoltBookGroupApi = (opt) => {
    const path = '/api/user/join-molt-book-group';
    const url = basePath + path;
    const p = {};
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 获取vnc信息
  * @param params ParamsgetVncCreateApi
  
  * @param opt ajax config
  * @returns models.VncInfo
  */
const getVncCreateApi = (params, opt) => {
    const path = '/api/vnc/view';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('read_only' in params)
        p.query.read_only = params.read_only;
    if ('task_id' in params)
        p.query.task_id = params.task_id;
    ajax.check(params.task_id, 'task_id');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};

export { deleteConversationApi, downloadBatchTestExcel, gaiaUploadPage, getAddWhiteList, getApeInfoApi, getBasicDataApi, getBatchTestResults, getBatchTestStatus, getConversationDetailApi, getConversationEventsApi, getConversationListApi, getConversationLlmTraceApi, getConversationMsgEventStreamApi, getConversationPageListApi, getConversationRunningApi, getConversationSearchApi, getConversationShareApi, getCookieListApi, getFastActionApi, getFileApi, getFileConvertMdToPdf, getFileConvertToPdf, getFileDownload, getGetUserInfoApi, getGroupClawCountApi, getGroupQueryApi, getHealthCheck, getInKimGroupApi, getKnowledgeListApi, getLlmTest, getLogin, getMarioDeepSearchApi, getMarioMcpConfigListApi, getMarioMcpConfigPreviewApi, getMarioMcpMarketListApi, getMarioSearchConfigApi, getMarioSearchTypesApi, getMcpConfigApi, getMcpCustomListApi, getMcpOfficialListApi, getMyBatches, getOpenApiChatDetailApi, getReadCsvHeaderController, getRobotStatsApi, getSchedulerListApi, getSchedulerRecordListApi, getShowCaseApi, getSsoLogin, getStartAnalysisController, getTaskAbortAllApi, getTaskAbortApi, getTaskCreateApi, getTaskGetTasksApi, getTemplateDetailApi, getTemplateListApi, getTestListApi, getTestListModelsApi, getTestListToolsApi, getToolUsedEventStreamApi, getUserApi, getUserGroupQueryApi, getUserQueryApi, getVncCreateApi, marioSchedulerDelete, marioSchedulerDetail, marioSchedulerEnabled, marioSchedulerList, marioSchedulerRecordList, marioSchedulerRun, marioSchedulerSave, postAnalysisBackApi, postApeVersionApi, postChatApi, postConversationApi, postConversationChatApi, postConversationChatStopApi, postConversationDetailsApi, postConversationRenameApi, postConversationShareApi, postConversationUserOperatedApi, postCookieEnableApi, postCookieGlobalDisableApi, postFilePostDocs, postFileUpload, postInternalAuditChatController, postInternalAuditChatStopApi, postInternalAuditDataCleaningApi, postJoinMoltBookGroupApi, postKnowledgeAddApi, postKnowledgeAddSystemKnowledgeApi, postKnowledgeCreateIndexApi, postKnowledgeDeleteApi, postKnowledgeEnableApi, postLlmDebugApi, postMarioDeepSearchApi, postMarioMcpAuthUpdate, postMarioMcpBpmAuth, postMarioMcpMarkFirstCreateClickedApi, postMarioMcpNormalAuth, postMarioMcpUnauth, postMarioSearchTypesApi, postMcpAddCustomConfigApi, postMcpDeleteCustomConfigApi, postMcpEditCustomConfigApi, postMcpEnableConfigApi, postMcpEnableCustomConfigApi, postMessageSenderApi, postOpenApiChatApi, postQuickChatApi, postRiskDetectionQueryApi, postSchedulerDeleteApi, postSchedulerEnabledApi, postSchedulerSaveApi, postSubmitFeedbackApi, postTemplateSaveApi, postTemplateViewApi, postTestAgentApi, postTestPromptApi, postTestRetryApi, postText2SqlApi, startGaiaBatchTest, stopBatchTestConversations };
